import React, { Component } from "react";
import { Div, Text, Input, Button, Image } from "atomize";
import InnerHTML from "../../utilities/innerHtml";

import { updateActiveCampaignForm } from "../../utilities/helpers";

export default class MarketingScheduleDemo extends Component {
  render() {
    const { form, title } = this.props;

    return (
      <Div>
        <Div d="flex" className="marketing">
          <Div
            d="flex"
            align="center"
            //minH="100vh"
            // w={{ xs: "100vw", lg: "40vw" }}
            bg="white"
            textColor="black"
          >
            <Div
              w={{ xs: "100%" }}
              //maxW="35rem"
              d="flex"
              flexDir="column"
              justify="space-evenly"
              //maxH="100%"
              p={{
                y: { xs: "3.5rem", md: "2.25rem" },
                l: { xs: "1.5rem", md: "3rem" },
                r: { xs: "1.8rem", md: "3rem" },
              }}
              m="0 auto"
            >
              <Text
                textSize={{
                  xs: "caption4",
                  md: "subheader6",
                }}
                className="form-heading"
                textWeight="700"
                m={{ b: "2.25rem" }}
                maxW="23rem"
              >
                {title}
              </Text>

              {typeof window !== "undefined" && (
                <InnerHTML html={updateActiveCampaignForm(form)} />
              )}
            </Div>
          </Div>
        </Div>
      </Div>
    );
  }
}
